export default defineNuxtRouteMiddleware(to => {
  if (import.meta.server) return

  const { checkAuth } = useAuth()

  // Only redirect away from signin if authenticated
  if (to.path === '/signin' && checkAuth()) {
    return navigateTo('/samples')
  }
})
